import { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router';

import { LoadingScreen } from '@zeta-core';
import { CompactErrorPage } from '../../layouts/compact-layout';
import { DashboardLayout } from '../../layouts/dashboard-layout';

const RiskToleranceQuestions = lazy(() => import('../../pages/dashboard/client-profile/risk-questions'));

const RiskRoutes = [
  {
    path: 'risk-questionnaire',
    element: (
      <ErrorBoundary FallbackComponent={CompactErrorPage}>
        <DashboardLayout noData>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </ErrorBoundary>
    ),
    children: [
      { path: '', element: <RiskToleranceQuestions /> },
      { path: '*', element: <RiskToleranceQuestions /> },
    ],
  },
];

export default RiskRoutes;
